import { ReactNode } from 'react';
import { ModuleSpacing } from '~/lib/data-contract';
import styles from './container.module.css';
import clsx from 'clsx';

type Breaks = 'small' | 'medium' | 'large';

export type ContainerProps = React.HTMLAttributes<HTMLDivElement> & {
    spacingTop?: ModuleSpacing['spacingTop'];
    spacingBottom?: ModuleSpacing['spacingBottom'];
    hasGutter?: boolean | Breaks;
    children: ReactNode;
    hideMobile?: boolean;
    hideDesktop?: boolean;
    className?: string;
};

export const Container = ({
    children,
    hasGutter,
    spacingTop,
    spacingBottom,
    hideMobile,
    hideDesktop,
    className,
    ...rest
}: ContainerProps) => {
    const spacingTopClass = spacingTop ?? 'default';
    const spacingBottomClass = spacingBottom ?? 'default';
    return (
        <div
            className={clsx(
                styles.root,
                className,
                { [styles.hasGutter]: hasGutter === true },
                { [styles[`gutterFrom-${hasGutter}`]]: typeof hasGutter === 'string' },
                { [styles[`spacingTop-${spacingTopClass}`]]: spacingTopClass },
                { [styles[`spacingBottom-${spacingBottomClass}`]]: spacingBottomClass },
                { [styles.hideMobile]: hideMobile },
                { [styles.hideDesktop]: hideDesktop }
            )}
            {...rest}
        >
            {children}
        </div>
    );
};
